export default __webpack_public_path__ + "static/media/instagram.19dc394e.svg";